export default __webpack_public_path__ + "static/media/news6.b990abdb.mp4";